import { Maximize2, Minimize2, Volume2, VolumeOff } from 'lucide-react'
import { useConfig } from '../../contexts/config.context'
import { VoiceWave } from './VoiceWave'
import { mergeClasses } from '../../lib/mergeClasses'


const HeaderSection = ({ isPlaying, isThinking, isMinimize, setIsMinimize }: {
  handleClose: () => void,
  isPlaying: boolean | undefined,
  isThinking: boolean | undefined,
  isMinimize?: boolean,
  setIsMinimize?: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const { config, updateConfig } = useConfig()
  return (
    <div className="">
      <div className="flex items-center justify-between">
        <div className='flex flex-row gap-2 items-center'>
          <img
            src={config.remote?.character.avatar || "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150"}
            alt={config.remote?.character.name || "AI Avatar"}
            className='w-10 h-10 rounded-full object-cover'
          />
          <h1 className="!text-white !font-semibold !text-xl !p-0 !m-0">{config.remote?.character.name || "Jenna"}
            {
              isThinking ? (
                <p className="!text-white !text-sm !p-0 !m-0">Thinking</p>
              ) : (
                <p className="!text-white !text-sm !p-0 !m-0">AI Assistant</p>
              )
            }
          </h1>

        </div>
        <div className="flex items-center gap-3">
          {
            isMinimize ? (
              <Maximize2
                className={mergeClasses("w-4 h-4  !cursor-pointer")}
                onClick={() => {
                  if (setIsMinimize)
                    setIsMinimize(false)
                }}
              />
            ) : (
              <Minimize2
                className={mergeClasses("w-4 h-4 !text-white !cursor-pointer")}
                onClick={() => {
                  if (setIsMinimize) {
                    setIsMinimize(true)
                  }
                }}
              />
            )
          }
          {
            config.muted ? (
              <VolumeOff
                className={mergeClasses("w-4 h-4 !text-red-400 !cursor-pointer", {
                  hidden: config.activeMode === 'chat'
                })}
                onClick={() => {
                  updateConfig({ muted: false })
                }}
              />
            ) : (
              <Volume2
                className={mergeClasses("w-4 h-4 !text-white !cursor-pointer", {
                  hidden: config.activeMode === 'chat'
                })}
                onClick={() => {
                  updateConfig({ muted: true })
                }}
              />
            )
          }
          {/* <Minus size={20} onClick={handleClose} className='cursor-pointer' /> */}
          {/* {!isMinimize && <X size={20} onClick={handleClose} className='cursor-pointer' />} */}
        </div>
      </div>
      {!isMinimize && <div className="flex flex-col gap-2 items-center border-2 border-white/50 h-12 py-2  rounded-full justify-center  mt-4 ">
        <VoiceWave isWaveMoving={isPlaying} />
      </div>
      }
    </div>)
}

export default HeaderSection

